<template>
  <div class="footer-drainage" v-if="pathUrl === 'home' && drainageShow === '1'">
    <div class="footer-drainage-con">
      <div class="footer-close" @click="drainageClose"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "zhDrainage",
  data() {
    return {
      pathUrl: '',
      drainageShow: '0',
    };
  },
  watch: {
    '$route.path' (val) {
      this.pathUrl = val === '/' ? 'home' : ''
    },
  },
  created () {
    // const drainageShow = localStorage.getItem('drainageShow')
    this.drainageShow = '1'
    this.pathUrl = this.$route.path === '/' ? 'home' : ''
  },
  methods:{
    drainageClose(){
      this.drainageShow = false
      // localStorage.setItem('drainageShow', '0')
      setTimeout(() => {
        // localStorage.setItem('drainageShow', '1')
        this.drainageShow = '1'
      },360000)
    }
  }
}
</script>
<style lang="scss">
.footer-drainage{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 189px;
  background: url('https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220601_16430514639ab8666246018e7ca28477922126.png') no-repeat center ;
  background-size: 1920px 189px;
  z-index: 200;
  .footer-drainage-con{
    width: 1180px;
    height: 189px;
    margin: 0 auto;
    position: relative;
    .footer-close{
      cursor: pointer;
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: 100px;
      right: -6px;
    }
  }
}
</style>